module.exports = __webpack_public_path__ + "img/Picture1.c6afb263.jpg";